import { Injectable, signal } from '@angular/core';
import { CourseI } from '../courses/interfaces/course.interface';
import { FilterCoursesI } from '../courses/interfaces/filter-courses.interface';
import { FilterInstructorsI } from '../instructors/interfaces/filter-instructors.interface';
import { InstructorI } from '../instructors/interfaces/instructor.interface';
import { FilterStudentsI } from '../students/interfaces/filter-students.interface';
import { StudentI } from '../students/interfaces/student.interface';
import { FilterProgramsI } from '../programs/interfaces/filter-programs.interface';
import { DepartmentI } from './interfaces/department.interface';
import { ProgramI } from '../programs/interfaces/program.interface';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  constructor() {}

  selectedDepartment = signal<DepartmentI | null>(null);

  filterDepartments = signal<FilterProgramsI | null>(null);

  updateDepartment = signal<DepartmentI | null>(null);

  createDepartment = signal<DepartmentI | null>(null);

  removeDepartment = signal<DepartmentI | null>(null);

  // ******************************************** ||

  filterCourses = signal<FilterCoursesI | null>(null);

  updateCourse = signal<CourseI | null>(null);

  createCourse = signal<CourseI | null>(null);

  // ******************************************** ||

  filterStudents = signal<FilterStudentsI | null>(null);

  updateStudent = signal<StudentI | null>(null);

  createStudent = signal<StudentI | null>(null);

  // ******************************************** ||

  filterInstructors = signal<FilterInstructorsI | null>(null);

  updateInstructor = signal<InstructorI | null>(null);

  createInstructor = signal<InstructorI | null>(null);

  // ******************************************** ||
  filterPrograms = signal<FilterProgramsI | null>(null);

  updateProgram = signal<ProgramI | null>(null);

  createProgram = signal<ProgramI | null>(null);

  removeProgram = signal<ProgramI | null>(null);

  // ******************************************** ||
}
